module.exports = __webpack_public_path__ + "img/collection-engagementRingsEssentials@2x.81ec063.jpg";